"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isHeaderPredicate = void 0;
/**
 * Typeguard checking whether the object is an {@link IHeaderPredicate} instance.
 * @public
 */
function isHeaderPredicate(obj) {
    return typeof obj === "function";
}
exports.isHeaderPredicate = isHeaderPredicate;
//# sourceMappingURL=HeaderPredicate.js.map